/* Swipe down on the top of the cart bottom sheet to close it (phones and tablets). */
(function () {
  const ZONE = 56; // px from the top of the sheet that starts a drag
  const CLOSE_AT = 100;
  const mq = window.matchMedia('(max-width: 989px)');
  let sheet = null;
  let drawer = null;
  let startY = null;
  let dy = 0;

  function move(e) {
    if (startY === null) return;
    dy = Math.max(0, e.clientY - startY);
    sheet.style.transform = `translate(0, ${dy}px)`;
  }

  function end() {
    if (startY === null) return;
    startY = null;
    sheet.classList.remove('is-dragging');
    sheet.style.transform = '';
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', end);
    window.removeEventListener('pointercancel', end);
    if (dy > CLOSE_AT && drawer && typeof drawer.close === 'function') drawer.close();
    dy = 0;
  }

  document.addEventListener('pointerdown', (e) => {
    if (!mq.matches) return;
    const content = e.target.closest('cart-drawer.popup-modal .popup-modal__content');
    if (!content) return;
    if (e.target.closest('button, a, input, select, textarea, summary')) return;
    const top = content.getBoundingClientRect().top;
    if (e.clientY - top > ZONE) return;
    sheet = content;
    drawer = content.closest('cart-drawer');
    startY = e.clientY;
    dy = 0;
    sheet.classList.add('is-dragging');
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  });
})();
